import { ConfigInterface } from 'swr';
import { api, useApi } from '@gik/core/api';
import { ResponsePromise } from 'ky';
import {
  ICreateInkindPageRequest,
  ICreateInkindPageResponse,
  InkindPageAPIModel,
  PatchInkindPageRequest,
} from '../../core/models/gik/InkindPage';
import { parseUrl } from '../../core/api/swr';
import { StatusCodes } from 'http-status-codes';
import { BadRequest } from '../HttpErrors';

const path = 'inkinds';

function getParams(inkindRouteIds: string[]) {
  return {
    include: inkindRouteIds.join(','),
    per_page: 1000,
  };
}

export function getInkinds(inkindRouteIds: string[]): ResponsePromise {
  const finalUrl = parseUrl(path, {
    searchParams: getParams(inkindRouteIds),
  });

  return api.get(finalUrl);
}

export function useInkinds(inkindRouteIds?: string[], config?: ConfigInterface) {
  return useApi<InkindPageAPIModel[]>(inkindRouteIds ? path : null, config, {
    searchParams: getParams(inkindRouteIds || []),
  });
}

export async function createInkind(request: ICreateInkindPageRequest): Promise<ICreateInkindPageResponse> {
  const response = await api.post(path, {
    json: request,
  });

  if (!response.ok) {
    switch (response.status) {
      case StatusCodes.BAD_REQUEST:
        throw new BadRequest('Failed to create page:');
      default:
        throw response;
    }
  } else {
    return response.json();
  }
}

export async function patchInkind(inkindRouteId: string, changes: PatchInkindPageRequest): Promise<void> {
  const url = `${path}/${inkindRouteId}`;
  const response = await api.patch(url, {
    json: changes,
  });

  if (!response.ok) {
    switch (response.status) {
      case StatusCodes.BAD_REQUEST:
        throw new BadRequest('Failed to update page:');
      default:
        throw response;
    }
  }
}
